module.exports = __webpack_public_path__ + "static/media/chrome_logo.050255bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/chrome_logo.png
// module id = 1208
// module chunks = 16